'use strict';

angular.module('AcaApp').factory('ManagedUserInformationService',
  ['$rootScope',
    '$window',
    'UserService',
    '$location',
    function($rootScope, $window, UserService, $location){
      return{
        findClient: function(){
          var that = this;
          UserService.FindClient().then(function(data){
            $window.sessionStorage.isDemo = data.result.DataObject.IsDemoClient;
            $window.sessionStorage.userLicense = data.result.DataObject.License;
            $window.sessionStorage.cid = data.result.DataObject.CID;
            $window.sessionStorage.customerName = data.result.DataObject.Name;
            $window.sessionStorage.isManagedServices = data.result.DataObject.IsManagedServices;
          });
        },
        isManagedServicesAndNotSovosProfile: function(){
          return (this.isManagedServices() && $window.sessionStorage.profile !== 'CNV_ACASOVOS');
        },
        checkManagedServices: function(page){
          switch(page){
            case 'import':
              if(this.isManagedServicesAndNotSovosProfile()){
                $location.path('/');
              }
            break;
            case 'send':
              if(this.isManagedServicesAndNotSovosProfile()){
                var locationSearch = $location.search();
                if(_.isEmpty(locationSearch)){
                  $location.path('/');
                }
              }
            break;
            case 'corrections':
            case 'printservice':
            case 'aca':
              if(this.isManagedServicesAndNotSovosProfile()){
                $location.path('/');
                $location.search('');
              }
            break;
          }
        },
        getCID: function(){
          return $window.sessionStorage.cid;
        },
        getCustomerName: function(){
          return $window.sessionStorage.customerName;
        },
        isManagedServices: function(){
          return $window.sessionStorage.isManagedServices === 'true';
        },
        findDataToApprove: function(param, callback){
          var that = this;
          UserService.findDataToApprove(param).then(function(data){
            data.result.arrayApproval = _.isEmpty(data.result) ? undefined : that.dataToArray(data.result.Description);
            callback(data.result);
          });
        },
        dataToArray: function(description){
          var arrayParsed, arrayData = [];
          var arrayPrint = description.split(';');
          _.each(arrayPrint, function(element){
            arrayParsed = element.split(':');
            arrayData[arrayParsed[0]] = arrayParsed[1];
          });
          return arrayData;
        }
      };
    }
  ]);